module.exports = __webpack_public_path__ + "static/media/8.ff803b4f.jpg";